/*
 * Copyright (c) 2025 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Permit } from './permits';

//this is an example of cabinet permits, to be used just for mock-data
export const InspectorCabinet: Permit[] = [
    'DOCUMENT_PICTURE_SCREEN',
    'USER_SETTINGS_INFO_SCREEN',
    'USER_SETTINGS_SECURITY_SCREEN',
    'INSPECTOR_HOME_SCREEN',
    'INFOGRAPHICS_FIN_SCREEN',
    'INFOGRAPHICS_TECH_SCREEN',
    'STATISTICS_SCREEN',
    'ALERTS_LIST_SCREEN',
    'ALERT_DETAILS_SCREEN',
    'REPORTS_SCREEN',
    'STORES_MAP_SCREEN',
    'CASHBOXES_MAP_SCREEN',
    'OPERATORS_LIST_SCREEN',
    'OPERATOR_CARD_SCREEN',
    'COMPANIES_LIST_SCREEN',
    'COMPANY_CARD_SCREEN',
    'STORES_LIST_SCREEN',
    'STORE_CARD_SCREEN',
    'CASHBOXES_LIST_SCREEN',
    'CASHBOX_CARD_SCREEN',
    'DOCUMENTS_LIST_SCREEN',
    'DOCUMENT_CARD_SCREEN',
    'DEVICES_LIST_SCREEN',
    'DEVICE_CARD_SCREEN',
    'CASHREGISTER_MODELS_LIST_SCREEN',
    'CASHREGISTER_MODEL_CARD_SCREEN',
    'REGISTRY_WRAPPER',
    'MAPS_WRAPPER',
    'INFOGRAPHICS_WRAPPER',

    'CASHBOX_ERRORS',
    'CASHBOX_LAST_AUDIT_DATE',
    'CASHBOX_STATUS_COMMENT',
    'CASHBOX_TURNOVERS',
    'CASHBOX_DOCUMENTS',
    'CASHBOX_MODE_HISTORY',
    'CASHBOX_STATUS_HISTORY',
    'CASHBOX_REPLACEMENT',
    'CASHBOX_CLOCK_STATUS_HISTORY',
    'CASHBOX_AUDIT_HISTORY',
    'CASHBOX_ALERTS_HISTORY',
    'CASHBOX_GPS_TRACKING',
    'CASHBOX_CHECKSUM_HISTORY',
    'CASHBOX_PERIOD_FILTERS',
    'CASHREGISTER_OS_AND_SOFTWARE_VERSION',
    'CASHREGISTER_SOFTWARE_VERSIONS_FILTER',
    'DEVICE_NUMBER_AND_VERSIONS',
    'STORE_TAX_AUTHORITY',
    'STORE_ACTIVITY',
    'AI_CLASSIFICATION',
    'COMPANY_NUMBER_NAME_STATUS',
    'COMPANY_TAXATION_TYPE',
    'OPERATOR_NAME',
    'OPERATOR_TAX_NUMBER',
    'DOCUMENT_ID',
];

const DirectorSpecial: Permit[] = [
    'ADMIN_USERS_LIST_SCREEN',
    'ALERTS_SETTINGS_SCREEN',
    'ALERT_EXECUTION_LOGS_SCREEN',
    'ALERT_RULES_SCREEN',
    'SERVICE_SCREEN',

    'CASHBOX_SERVICE',

    'CHANGE_CASHBOX_STATUS_ACTION',
    'EDIT_ERP_POS_INTEGRATION_STATUS_ACTION',
];

const ExpertSpecial: Permit[] = ['SERVICE_SCREEN', 'CASHBOX_SERVICE'];

//this is an example of cabinet permits, to be used just for mock-data
export const DirectorCabinet: Permit[] = InspectorCabinet.concat(DirectorSpecial);

//this is an example of cabinet permits, to be used just for mock-data
export const ExpertCabinet: Permit[] = InspectorCabinet.concat(ExpertSpecial);

//this is an example of cabinet permits, to be used just for mock-data
export const CentralInspectorCabinet: Permit[] = [
    'DOCUMENT_PICTURE_SCREEN',
    'USER_SETTINGS_INFO_SCREEN',
    'USER_SETTINGS_SECURITY_SCREEN',
    'CENTRAL_INSPECTOR_INFOGRAPHICS_SCREEN',
    'CENTRAL_INSPECTOR_STATISTICS_SCREEN',
    'REPORTS_SCREEN',
    'STORES_MAP_SCREEN',
    'CASHBOXES_MAP_SCREEN',
    'COMPANIES_LIST_SCREEN',
    'COMPANY_CARD_SCREEN',
    'STORES_LIST_SCREEN',
    'STORE_CARD_SCREEN',
    'CASHBOXES_LIST_SCREEN',
    'CASHBOX_CARD_SCREEN',
    'DOCUMENTS_LIST_SCREEN',
    'DOCUMENT_CARD_PICT_SCREEN',
    'REGISTRY_WRAPPER',
    'MAPS_WRAPPER',

    'CASHBOX_STATUS_COMMENT',
    'CASHBOX_TURNOVERS',
    'CASHBOX_DOCUMENTS',
    'CASHBOX_MODE_HISTORY',
    'CASHBOX_STATUS_HISTORY',
    'CASHBOX_REPLACEMENT',
    'CASHBOX_CLOCK_STATUS_HISTORY',
    'CASHBOX_PERIOD_FILTERS',
    'CASHREGISTER_OS_AND_SOFTWARE_VERSION',
    'DEVICE_NUMBER_AND_VERSIONS',
    'STORE_TAX_AUTHORITY',
    'STORE_ACTIVITY',
    'AI_CLASSIFICATION',
    'COMPANY_NUMBER_NAME_STATUS',
    'COMPANY_TAXATION_TYPE',
    'OPERATOR_NAME',
    'OPERATOR_TAX_NUMBER',
];

//this is an example of cabinet permits, to be used just for mock-data
export const RegionalInspectorCabinet: Permit[] = [
    'DOCUMENT_PICTURE_SCREEN',
    'USER_SETTINGS_INFO_SCREEN',
    'USER_SETTINGS_SECURITY_SCREEN',
    'REGIONAL_INSPECTOR_INFOGRAPHICS_SCREEN',
    'REPORTS_SCREEN',
    'STORES_LIST_SCREEN',
    'STORE_CARD_SCREEN',
    'CASHBOXES_LIST_SCREEN',
    'CASHBOX_CARD_SCREEN',
    'DOCUMENTS_LIST_SCREEN',
    'DOCUMENT_CARD_PICT_SCREEN',

    'CASHBOX_STATUS_COMMENT',
    'CASHBOX_TURNOVERS',
    'CASHBOX_DOCUMENTS',
    'CASHBOX_MODE_HISTORY',
    'CASHBOX_STATUS_HISTORY',
    'CASHBOX_REPLACEMENT',
    'CASHBOX_CLOCK_STATUS_HISTORY',
    'CASHBOX_PERIOD_FILTERS',
    'CASHREGISTER_OS_AND_SOFTWARE_VERSION',
    'DEVICE_NUMBER_AND_VERSIONS',
    'STORE_ACTIVITY',
    'AI_CLASSIFICATION',
    'COMPANY_NUMBER_NAME_STATUS',
    'COMPANY_TAXATION_TYPE',
    'OPERATOR_NAME',
    'OPERATOR_TAX_NUMBER',
];

//this is an example of cabinet permits, to be used just for mock-data
export const OperatorCabinet: Permit[] = [
    'USER_SETTINGS_INFO_SCREEN',
    'OPERATOR_HOME_SCREEN',
    'COMPANIES_LIST_SCREEN',
    'COMPANY_CARD_SCREEN',
    'STORES_LIST_SCREEN',
    'STORE_CARD_SCREEN',
    'CASHBOXES_LIST_SCREEN',
    'CASHBOX_CARD_SCREEN',
    'DEVICES_LIST_SCREEN',
    'DEVICE_CARD_SCREEN',
    'CASHREGISTER_MODELS_LIST_SCREEN',
    'CASHREGISTER_MODEL_CARD_SCREEN',
    'SERVICE_SCREEN',

    'CASHBOX_ERRORS',
    'CASHBOX_LAST_AUDIT_DATE',
    'CASHBOX_STATUS_COMMENT',
    'CASHBOX_GPS_TRACKING',
    'CASHBOX_LAST_DOCUMENT',
    'CASHBOX_SERVICE',
    'CASHBOX_PERIOD_FILTERS',
    'CASHREGISTER_OS_AND_SOFTWARE_VERSION',
    'CASHREGISTER_SOFTWARE_VERSIONS_FILTER',
    'DEVICE_NUMBER_AND_VERSIONS',
    'STORE_ACTIVITY',
    'STORE_TAX_AUTHORITY',
    'COMPANY_NUMBER_NAME_STATUS',
    'COMPANY_TAXATION_TYPE',

    'EDIT_ERP_POS_INTEGRATION_STATUS_ACTION',
];

//this is an example of cabinet permits, to be used just for mock-data
export const TaxpayerCabinet: Permit[] = [
    'TAXPAYER_HOME_SCREEN',
    'REPORTS_SCREEN',
    'STORES_LIST_SCREEN',
    'STORE_CARD_SCREEN',
    'CASHBOXES_LIST_SCREEN',
    'CASHBOX_CARD_SCREEN',
    'DOCUMENTS_LIST_SCREEN',
    'DOCUMENT_CARD_PICT_SCREEN',

    'CASHBOX_LAST_AUDIT_DATE',
    'CASHBOX_DOCUMENTS',
    'CASHBOX_MODE_HISTORY',
    'CASHBOX_CLOCK_STATUS_HISTORY',
    'CASHBOX_GPS_TRACKING',
    'STORE_TAX_AUTHORITY',
    'OPERATOR_NAME',
];
